import tiktokLogo from "../../assets/logos/tiktokLogo.png";
import { useTranslation } from "react-i18next";
import { FaXTwitter } from "react-icons/fa6";
import { FaTelegram } from "react-icons/fa";
import { IoLogoYoutube } from "react-icons/io";
import { FaTiktok } from "react-icons/fa";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <div className='grid lg:grid-cols-2 place-items-center md:bottom-0 w-full md:z-40 lg:px-32 py-5 bg-white text-MetallicBlue gap-5 px-4 md:px-0'>
            <div className='flex flex-col gap-2 w-full px-5'>
                <p className='text-xl font-semibold'>Follow us</p>
                <div className='flex gap-5 mx-auto md:mx-0'>
                    <a
                        href='https://www.facebook.com/IDethiopia/?ref=pages_you_manage'
                        target='_blank'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105 '
                    >
                        <svg
                            aria-hidden='true'
                            focusable='false'
                            data-prefix='fab'
                            data-icon='facebook-f'
                            className='w-3 '
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 320 512'
                        >
                            <path
                                fill='currentColor'
                                d='M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'
                            ></path>
                        </svg>
                    </a>

                    <a
                        href='https://twitter.com/IDethiopia'
                        target='_blank'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105'
                    >
                        <FaXTwitter />{" "}
                    </a>

                    <a
                        href='https://www.youtube.com/channel/UCf3SnLcgf5jzxhkeMTf2fRA'
                        target='_blank'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105'
                    >
                        <IoLogoYoutube />
                    </a>

                    <a
                        href='https://www.linkedin.com/company/idethiopia'
                        target='_blank'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105'
                    >
                        <svg
                            aria-hidden='true'
                            focusable='false'
                            data-prefix='fab'
                            data-icon='linkedin-in'
                            className='w-5'
                            role='img'
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 448 512'
                        >
                            <path
                                fill='currentColor'
                                d='M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z'
                            ></path>
                        </svg>
                    </a>

                    <a
                        href='https://t.me/IDethiopia'
                        target='_blank'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105'
                    >
                        <FaTelegram />
                    </a>
                    <a
                        target='_blank'
                        href='https://www.tiktok.com/@idethiopia'
                        className='flex text-mMetallicBlue justify-center border-2 border-white rounded-full w-9 h-9 place-items-center hover:border-none hover:bg-green hover:scale-105'
                    >
                        <FaTiktok />{" "}
                    </a>
                </div>
            </div>
            <div className='flex flex-col justify-center px-5 gap-1.5 w-full'>
                <div className='flex flex-wrap justify-center w-full gap-0 mb-0 text-xs tracking-tighter text-left md:justify-start md:tracking-tight md:gap-1 md:text-base place-items-center'>
                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {t("help")}&nbsp;| &nbsp;
                    </a>
                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                        to='https://linktr.ee/NIDP?utm_source=qr_code'
                    >
                        {t("footer-socials")}&nbsp;| &nbsp;
                    </a>
                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {t("website-policy")}&nbsp;| &nbsp;
                    </a>

                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {" "}
                        {t("terms-conditions")}&nbsp;|&nbsp;
                    </a>

                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {" "}
                        {t("copyright-policy")}&nbsp;|&nbsp;
                    </a>
                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {" "}
                        {/* Copyright Policy&nbsp;|&nbsp; */}{" "}
                        {t("career-footer")} &nbsp;| &nbsp;
                    </a>
                    <a
                        href=''
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                    >
                        {" "}
                        {/* Copyright Policy&nbsp;|&nbsp; */} {t("print")}
                        &nbsp;| &nbsp;
                    </a>
                    {/* <a
                                        href='https://card-order.fayda.et/'
                                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                                    >
                                        {t("print")}&nbsp;| &nbsp;
                                    </a>
                                    {/* <Link
                                        to='/cardprint'
                                        href='https://card-order.fayda.et/'
                                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green'
                                    >
                                        {t("card")}&nbsp;| &nbsp;
                                    </Link> */}
                    {/* <a
                        className='text-mMetallicBlue font-medium hover:scale-105 hover:text-green hover:cursor-pointer'
                        onClick={handleDownloadClick}
                        // download='logos.zip'
                    >
                        {t("logo-footer")}
                    </a> */}
                </div>
                <p className='mt-0 font-medium  text-mMetallicBlue dark:text-mMetallicBlue md:text-sm text-center place-items-center flex md:justify-start justify-center text-xs'>
                    {new Date().getFullYear()} {t("national-id")}{" "}
                    {t("all-rights")}
                </p>
            </div>
        </div>
    );
};

export default Footer;
